import styled, { css } from "styled-components"
import SearchResult from "./search-result"

export default styled(SearchResult)`
  .HitCount {
    display: flex;
    justify-content: flex-end;
  }
  h2{
    text-align:left
  }
  
  .Hits {
    ul {
      list-style: none;
      margin-left: 0;
      display: grid; 
      grid-template-columns: 1fr 1fr 1fr; 
      grid-template-rows: 1fr 1fr 1fr; 
      gap: 2%  2%; 
      margin-bottom: 10%;
      padding-left: 0px;
    }

    li.ais-Hits-item {
      margin-bottom: 1em;
      background: #DFE6ED;
      margin : 10px;
      border-radius: 10px;
      width: 90%;
      height: 90%;
      a {
        color: black;
        text-decoration: none;
        display : flex;
        column-gap: 10px;
        align-items: center;
        
    flex-direction: column;
        .image {
          min-width : 60px;
          width : 15%;
          min-height: 60px;
          background-position: center;
          background-size: contain;
          border-radius: 10px;
          margin : 10% 0; 
        }

        h4 {
          margin: 0 0 5px 0;
        }
        
        p {
          font-size: 75%;
          margin : 0;
        }
      }
    }
  }
`